<template>
	<div>
		<div id="main-wrapper">
			<Header />
			<NoSideBarMain />
		</div>
	</div>
</template>

<script>
import Header from "@/components/fixedcomponents/header.vue";
import NoSideBarMain from "@/components/Layout/NoSideBarMain";

export default {
	name: "LayoutNoSidebar",
	components: {
		Header,
		NoSideBarMain,
	},
	data() {
		return {};
	},
};
</script>
